import React, { Component } from 'react';
import PortfolioItem from '../portfolio/PortfolioItem';
import { forceCheck } from 'react-lazyload';
// import DownArrow from '../common/DownArror';
// import { Link as ScrollLink } from 'react-scroll';
export class Portfolio extends Component {
	state = {
		overlay: false,
		activeId: 1,
		projects: [
			{
				id: 1,
				name: 'blog',
				desc: 'A simple blog using Gatsby and Storyblok',
				image:
					'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_1016/v1533433636/portfolio-images/blog_web.png',
				imagem: 'https://res.cloudinary.com/dydyt6wbt/image/upload/v1532048963/blogm.png',
				links: [
					{ link: 'https://blog.barisozcetin.me', icon: 'Webpage', type: 'live demo' },
					{ link: 'https://github.com/barisozcetin/blog.barisozcetin.me', icon: 'Github', type: 'github' }
				]
			},
			{
				id: 2,
				name: 're-chat',
				desc: 'A chat application using React and Firebase',
				image: 'https://res.cloudinary.com/dydyt6wbt/image/upload/v1532129623/rechat.png',
				imagem: 'https://res.cloudinary.com/dydyt6wbt/image/upload/v1532996459/portfolio-images/re-chat_m.png',
				links: [
					{ link: 'https://re-chat.barisozcetin.me/', icon: 'Webpage', type: 'live demo' },
					{ link: 'https://github.com/barisozcetin/re-chat', icon: 'Github', type: 'github' }
				]
			},
			{
				id: 3,
				name: 'data-visualizations',
				desc: 'Data visualizations on resizable & sortable grid',

				image: 'https://res.cloudinary.com/dydyt6wbt/image/upload/v1534811930/portfolio-images/reports.png',
				imagem: 'https://res.cloudinary.com/dydyt6wbt/image/upload/v1534811930/portfolio-images/reports.png',
				links: [
					{ link: 'https://data-visualizations.barisozcetin.me', icon: 'Webpage', type: 'live demo' },
					{ link: 'https://github.com/barisozcetin/data-visualized', icon: 'Github', type: 'github' }
				]
			}
			// {
			// 	id: 3,
			// 	image:
			// 		'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_950/v1532996977/portfolio-images/bhidiroglu_desktop.png',
			// 	imagem: 'https://res.cloudinary.com/dydyt6wbt/image/upload/v1532996290/portfolio-images/bhidiroglu_mobil.png',
			// 	links: [
			// 		{ link: 'https://www.bhidiroglu.com', icon: 'Webpage', type: 'live demo' }
			// 		// { link: 'https://github.com/barisozcetin/blog.barisozcetin.me', icon: 'Github', type: 'github' }
			// 	]
			// }
		]
	};

	nextItem = () => {
		this.setState(
			(prevstate) => ({
				activeId: prevstate.activeId < 3 ? prevstate.activeId + 1 : 1
			}),
			forceCheck
		);
	};
	prevItem = () => {
		this.setState(
			(prevstate) => ({
				activeId: prevstate.activeId > 1 ? prevstate.activeId - 1 : 3
			}),
			forceCheck
		);
	};

	render() {
		return (
			<div id="portfolio" className="container">
				<div className="portfolio__container full-height text-center">
					<h1 className="section-title" ref={(title) => (this.title = title)}>
						Portfolio
					</h1>

					<div className="portfolio__grid" ref="portfolio_grid" style={{ '--text-color': '#ffffff' }}>
						{this.state.projects &&
							this.state.projects.map((project) => (
								<PortfolioItem
									key={project.id}
									image={project.image}
									imagem={project.imagem}
									links={project.links}
									description={project.desc}
									active={this.state.activeId === project.id}
								/>
							))}
					</div>
					{/* <span className="coming">COMING SOON</span> */}

					{/* <ScrollLink
            className="to-bottom"
            to="contact"
            smooth={true}
            duration={500}
          >
            <DownArrow />
					</ScrollLink> */}
					<button className="slide__button right" onClick={this.nextItem}>
						→
					</button>
					<button className="slide__button left" onClick={this.prevItem}>
						←
					</button>
				</div>
			</div>
		);
	}
}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/components/containers/Portfolio.js